module.exports = {
      id: "google-usage",
      viewBox: "0 0 533.5 544.3",
      url: __webpack_public_path__ + "svg-sprite-fef6f85605acbf641cce7cd75d6011b0.svg#google",
      toString: function () {
        return this.url;
      }
    }